import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEnitBrandSignal = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "currentColor",
	viewBox: "0 0 113.39 113.39",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M99.21,0H14.17C6.35,0,0,6.35,0,14.17v85.04c0,7.83,6.35,14.17,14.17,14.17h85.04c7.83,0,14.17-6.35,14.17-14.17V14.17c0-7.83-6.35-14.17-14.17-14.17ZM90.33,67.91h-22.43v22.43h-22.43v-22.43h-22.43v-7.48h22.43v-7.48h-22.43v-7.47h22.43v-22.43h22.43v22.43h22.43v22.43Z" })
});
export default SvgEnitBrandSignal;
